import { render } from "./TipInfoRecipient.vue?vue&type=template&id=0bbf5a5c&scoped=true"
import script from "./TipInfoRecipient.vue?vue&type=script&lang=js"
export * from "./TipInfoRecipient.vue?vue&type=script&lang=js"

import "./TipInfoRecipient.vue?vue&type=style&index=0&id=0bbf5a5c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bbf5a5c"]])

export default __exports__